'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var moment = _interopDefault(require('moment'));
var AccessTimeIcon = _interopDefault(require('@material-ui/icons/AccessTime'));
var styledComponents = require('./styled-components.js');

var TimePicker = function (props) {
    var onChange = props.onChange, title = props.title, _a = props.defaultTime, defaultTime = _a === void 0 ? '12:00' : _a, _b = props.error, error = _b === void 0 ? false : _b, _c = props.disablePast, disablePast = _c === void 0 ? false : _c;
    var _d = React.useState(moment(defaultTime, 'HH:mm')), selectedTime = _d[0], setSelectedTime = _d[1];
    var handleChange = function (newTime, value) {
        var reportValue = value;
        if (newTime) {
            var now = moment();
            if (disablePast && newTime.isBefore(now)) {
                setSelectedTime(now);
                reportValue = now.format('HH:mm');
            }
            else {
                setSelectedTime(newTime);
            }
        }
        if (reportValue)
            onChange(reportValue);
    };
    return (React__default.createElement("div", null,
        title && React__default.createElement(styledComponents.StyledInputLabel, null, title),
        React__default.createElement(styledComponents.StyledTimePicker, { ampm: false, variant: 'inline', value: selectedTime, onChange: handleChange, minutesStep: 5, keyboardIcon: React__default.createElement(AccessTimeIcon, null), error: error, inputVariant: 'outlined' })));
};

module.exports = TimePicker;
